<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@stores/auth'
import { useEventStore } from '@stores/event'
import Loading from '@sections/global/Loading.vue'
import RegisteredEventCategory from '@components/global/RegisteredEventCategory.vue'
import RegisteredEventCard from '@components/global/RegisteredEventCard.vue'

const auth = useAuthStore()
const store = useEventStore()
</script>

<template>
	<Loading v-if="!auth.isAuthed" />
	<section class="bg-gradient-to-bl from-logi-grey-600 via-black to-black pb-16 pt-28" v-else>
		<div class="container">
			<div class="flex flex-col gap-5 md:gap-10 lg:gap-14">
				<div class="flex flex-col gap-3">
					<h3>My Events</h3>
					<p class="text-white/70">{{ auth.user?.events?.length > 0 ? 'These are the events you have registered for.' : "You haven't registered for any events yet." }}</p>
				</div>
				<div class="flex min-h-[calc(100vh-603px)] flex-col gap-10">
					<RegisteredEventCategory title="Ongoing Events" v-if="auth.upcomingEvents.length > 0">
						<RegisteredEventCard v-for="event in auth.upcomingEvents" :key="event.slug" :event="event" />
					</RegisteredEventCategory>
					<RegisteredEventCategory title="Past Events" v-if="auth.pastEvents.length > 0">
						<RegisteredEventCard v-for="event in auth.pastEvents" :key="event.slug" :event="event" />
					</RegisteredEventCategory>
				</div>
			</div>
		</div>
	</section>
</template>
